import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets.app/images/logo.svg'
import _imports_1 from '@/assets.app/images/logo-dark.svg'


const _hoisted_1 = { class: "header header--desktop" }
const _hoisted_2 = { class: "header__inner container" }
const _hoisted_3 = { class: "header__logo" }

import { onBeforeMount, Raw, ref } from 'vue'

import { HeaderView } from '@/models/header'

import HeaderUserMenu from '@/app/components/header/UserMenu.vue'
import AppMenu from '@/app/components/header/AppMenu.vue'
import StartFreeTrialButton from './StartFreeTrialButton.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'AppDesktop',
  setup(__props) {

const view = ref<Raw<HeaderView>>(new HeaderView())

onBeforeMount(async () => {
  await view.value.init()
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: { name: 'home' },
          class: "header__logo-link"
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createElementVNode("img", {
              class: "header__logo-img header__logo-img--light",
              src: _imports_0,
              alt: "Shortform App"
            }, null, -1),
            _createElementVNode("img", {
              class: "header__logo-img header__logo-img--dark",
              src: _imports_1,
              alt: "Shortform App"
            }, null, -1)
          ]))]),
          _: 1
        })
      ]),
      _createVNode(AppMenu, {
        class: "header__nav",
        view: view.value
      }, null, 8, ["view"]),
      (view.value.showCtaButton)
        ? (_openBlock(), _createBlock(StartFreeTrialButton, {
            key: 0,
            class: "header__trial-btn"
          }))
        : _createCommentVNode("", true),
      _createVNode(HeaderUserMenu, {
        class: "header__user-menu",
        view: view.value
      }, null, 8, ["view"])
    ])
  ]))
}
}

})